import {
    makeStyles,
} from 'app/tss'

const BORDER_WIDTH = 3

const useStyles = makeStyles()((theme) => {
    return {
        root: {
            display: 'flex',
            justifyContent: 'space-between',
            backgroundColor: theme.palette.secondary[50],
            borderWidth: 1,
            borderStyle: 'solid',
            borderLeftWidth: 0,
            borderBottomWidth: 0,
            borderColor: theme.palette.secondary[300],
            borderTopRightRadius: theme.spacing(0.5),
            height: theme.spacing(4.5),
            minHeight: `${theme.spacing(4.5)} !important`,
            paddingLeft: theme.spacing(2),
            width: `calc(100% - ${theme.spacing(2)})`,
        },
        contentWrapper: {
            height: `calc(100% - ${Number(theme.shape.tabHeight) + BORDER_WIDTH}px)`,
            width: '100%',
            display: 'flex',
            flexGrow: 1,
            backgroundColor: theme.palette.secondary[50],
            borderWidth: 1,
            borderStyle: 'solid',
            borderLeftWidth: 0,
            borderColor: theme.palette.secondary[300],
            '@media print': {
                borderWidth: 0,
                backgroundColor: theme.palette.common.white,
            },
            borderBottomRightRadius: 4,
        },
        content: {
            height: '100%',
            padding: theme.spacing(2),
            display: 'flex',
            flexGrow: 1,
            overflow: 'auto',
            boxSizing: 'border-box',
            flexDirection: 'column',
            width: '100%',
        },
        loadingWrapper: {
            position: 'relative',
            height: '100%',
            width: '100%',
        },
    }
})

export default useStyles
